import { createTheme } from '@mui/material/styles';
import '@fontsource/titillium-web/600.css';
import '@fontsource/open-sans/400.css';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#30302F',
    },
    secondary: {
      main: '#ea621c',
      dark: '#d85e1e',
    },
    background: {
      default: '#f5f5f5',
      paper: '#ffffff',
    },
    text: {
      primary: '#333333',
      secondary: '#555555',
    },
  },
  typography: {
    fontFamily: 'Open Sans, sans-serif',
    h1: { fontFamily: 'Titillium Web, sans-serif' },
    h2: { fontFamily: 'Titillium Web, sans-serif' },
    h3: { fontFamily: 'Titillium Web, sans-serif' },
    h4: { fontFamily: 'Titillium Web, sans-serif' },
    h5: { fontFamily: 'Titillium Web, sans-serif' },
    h6: { fontFamily: 'Titillium Web, sans-serif' },
    button: { textTransform: 'none' },
    allVariants: {
      color: '#333333',
    },
  },
});

export default theme;
